<template>
    <div v-loading="formLoading">
      <!-- 搜索内容 -->
      <div class="filter-container">
        <el-form :inline="true" :model="queryParams">
          <!-- 地区部 -->
          <el-form-item label="地区部">
            <el-select
              filterable
              v-model="queryParams.areaName"
              placeholder="请选择区域"
              clearable
              @change="changeArea"
            >
              <el-option
                v-for="(item, index) in areaList"
                :key="index"
                :label="item.areaName"
                :value="item.areaName"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 国家 -->
          <el-form-item label="国家">
            <el-select
              filterable
              v-model="queryParams.countryName"
              placeholder="请选择国家"
              clearable
            >
              <el-option
                v-for="(item, index) in countryList.filter(item => {
                  return item.areaName == queryParams.areaName;
                })"
                :key="index"
                :label="item.countryName"
                :value="item.countryName"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 车型 -->
          <el-form-item label="车型">
            <el-select
              filterable
              v-model="queryParams.carModel"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="(item, index) in carModelList"
                :key="index"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 年份 -->
          <el-form-item label="年份">
            <el-date-picker
              type="year"
              value-format="yyyy"
              v-model="queryParams.years"
              placeholder="请选择"
              :clearable="false"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <!-- 月份 -->
          <el-form-item label="月份">
            <el-select filterable clearable v-model="queryParams.months">
              <el-option
                v-for="item in 12"
                :key="item"
                :label="item + '月'"
                :value="item < 10 ? '0' + item : item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 操作 -->
          <el-form-item label=" ">
            <el-button type="primary" size="small" @click="doSearch"
              >查询</el-button
            >
            <el-button type="primary" size="small" @click="handleResetQuery"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      
      <div v-if="showTab">
        <div class="title">
          {{ queryParams.countryName }} 市场
          {{ queryParams.months }} 月分析月报
        </div>
        <div class="time">
          更新日期：{{ showDataObj[this.pageIndex + "Time"] }}
        </div>
        <div class="hearder_title">
            <div class="flex_between">
              <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
              风险机会 <span style="color: red;">（围绕看差距、市场、行业、竞争、客户总结风险机会）</span>
              <el-button
                v-if="$route.query.operateType !== '查看'"
                size="mini"
                type="primary"
                class="title_btn"
                @click="handleSave('risk')"
                >保存</el-button
              >
            </div>
        </div>
        <risk ref="risk" />
        <div class="hearder_title">
            <div class="flex_between">
              <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
              定目标
              <span style="color: red;">（须填写“xx+1”月预计接单及关单数量，“xx+2”月预计接单数量）</span>
              <el-button
                v-if="$route.query.operateType !== '查看'"
                size="mini"
                type="primary"
                class="title_btn"
                @click="handleSave('targetRef')"
                >保存</el-button
              >
            </div>
        </div>
        <target-div ref="targetRef" />
        <div class="hearder_title">
            <div class="flex_between">
              <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
              定策略
              <span style="color:red;">（围绕风险机会、目标制定策略）</span>
              <el-button
                v-if="$route.query.operateType !== '查看'"
                size="mini"
                type="primary"
                class="title_btn"
                @click="handleSave('strategy')"
                >保存</el-button
              >
            </div>
        </div>
        <strategy ref="strategy" />
        <div class="hearder_title">
            <div class="flex_between">
              <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
              定要事
              <span style="color:red;">（结合策略制定“xx+1”月要事，要事完成日期不超过“xx+1”月25日）</span>
              <el-button
                v-if="$route.query.operateType !== '查看'"
                size="mini"
                type="primary"
                class="title_btn"
                @click="handleSave('important')"
                >保存</el-button
              >
            </div>
        </div>
        <important ref="important" />
        <div class="hearder_title">
            <div class="flex_between">
              <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
              定费用
              <el-button
                v-if="$route.query.operateType !== '查看'"
                size="mini"
                type="primary"
                class="title_btn"
                @click="handleSave('cost')"
                >保存</el-button
              >
            </div>
        </div>
        <cost ref="cost" />
        <div class="hearder_title">
            <div class="flex_between">
              <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
              要求事项
              <span style="color:red;">（原需支持事项）</span>
              <el-button
                v-if="$route.query.operateType !== '查看'"
                size="mini"
                type="primary"
                class="title_btn"
                @click="handleSave('requirement')"
                >保存</el-button
              >
            </div>
        </div>
        <requirement ref="requirement" />
      </div>

    </div>
</template>
  
<script>
import risk from "./components/risk.vue";
import strategy from "./components/strategy.vue";
import cost from "./components/cost.vue";
import targetDiv from "./components/targetTotal.vue";
import important from "./components/important.vue";
import requirement from "./components/requirement.vue";
import * as moment from "moment";
import {
  getAreaCountryListApi,
  getThreeDataApi
} from "@/api/saleTaskCollection";
import { getDictItem } from "@/util/dict";

export default {
  components: {
    risk,strategy,cost,targetDiv,important,requirement
  },
  data() {
    return {
      showTab:false,
      // 区域
      areaList: [],
      // 国家
      countryList: [],
      // 车型
      carModelList: [],
      // 搜索条件
      queryParams: {
        areaName: "", // 区域
        countryName: "", // 国家
        carModel: "", // 车型
        years: moment().format("YYYY"), // 年份
        months: moment().format("MM") // 月份
      },
      pickerOptions: {
        disabledDate(time) {
          const preYear = 2021;
          const afterYear = new Date().getFullYear();
          return time.getFullYear() > afterYear || time.getFullYear() < preYear;
        }
      },
      formLoading: false,
      pageIndex:'',
      
      showDataObj: {
        queryParams: {},
        
      },
    };
  },
  created() {
    // 获取区域国家
    this.getAreaCountryList();
    // 获取车型
    this.getCarTypeList();
    
  },

  methods: {
    // 获取地区国家列表
    async getAreaCountryList() {
      const res = await getAreaCountryListApi();
      this.areaList = res.data.saleAreaList || [];
      this.countryList = res.data.saleCountryList || [];
    },
    // 获取车型列表
    async getCarTypeList() {
      this.carModelList = await getDictItem("carType");
    },
    // 区域改变
    changeArea() {
      this.queryParams.countryName = "";
    },
    // 搜索
    async doSearch() {
      this.formLoading = true;
      try {
        const res = await getThreeDataApi({
          areaName: this.queryParams.areaName,
          countryName: this.queryParams.countryName,
          years:this.queryParams.years,
          months:this.queryParams.months,
        });
        if (res.status == 0) {
         let data = res.data || {};
         this.showTab = true;
         this.formLoading = false;
         this.$nextTick(()=>{
          this.$refs.important.init(data.threeMustdoList,this.queryParams)
          this.$refs.requirement.init(data.threeRequirementsThingsist)
          this.$refs.cost.init(data.threeMoneyList)
          this.$refs.risk.init(data.threeRiskOpportunityList)
          this.$refs.strategy.init(data.threeStrategyList)
          this.$refs.targetRef.init(data.threeTargetingtyList,this.queryParams)
          

        })

        } else {
          this.showTab = false;
          this.$DonMessage.error(res.message);
          this.formLoading = false;
        }
        // this.$refs.targetRef.init(data.threeTargetingtyList,this.queryParams)
        
        
        // this.$refs.targetRef.init()
      } catch (error) {
        this.showTab = false;
        this.formLoading = false;
      }
    },
    // 重置
    handleResetQuery() {
      this.queryParams = Object.assign({}, this.$options.data()?.queryParams);
      this.showTab = false;
    },
    // 时间更新
    updateTime(field, time) {
      if (field) {
        this.showDataObj[field] = time ? moment(time).format("YYYY-MM-DD") : "";
      } else {
        this.showDataObj[this.pageIndex + "Time"] = moment().format(
          "YYYY-MM-DD"
        );
      }
    },
    // 保存
    handleSave(refField) {
      let submitData = {};
        submitData = {
          years:this.queryParams.years,
          months:this.queryParams.months,
          areaName: this.queryParams.areaName,
          countryName: this.queryParams.countryName
        };
      
      this.$refs[refField].handleSave(submitData);
    }
  }
};
</script>
  
  <style lang="scss" scoped>
  .filter-container {
    padding: 30px 20px 0 20px;
    border-bottom: 5px solid #efefef;
    ::v-deep .el-input {
      width: 150px;
    }
  }
  .tabs_container {
    padding-top: 15px;
    ::v-deep {
      .el-tabs__item {
        font-size: 16px;
        height: 34px;
        line-height: 32px;
      }
      .el-tabs__nav-wrap {
        padding: 0 40px;
      }
      .el-tabs__nav-wrap::after {
        display: none;
      }
    }
  }
  .title {
    display: flex;
    justify-content: center;
    font-size: 18px;
    font-weight: 600;
    padding-top: 20px;
  }
  .time {
    display: flex;
    justify-content: right;
    font-size: 14px;
    padding: 0 20px;
  }
  .hearder_title {
     display: flex;
     align-items: center;
     justify-content: space-between;
     font-size: 14px;
     color: #333333;
     padding: 14px 10px 14px 20px;
     border-bottom: 1px solid #dcdee0;
     .title_icon {
       margin-right: 10px;
     }
     p {
       font-size: 16px;
       color: #4095e5;
       font-weight: bold;
       i {
         font-size: 18px;
         color: #4095e5;
         display: inline-block;
         margin-right: 5px;
       }
     }
    }
  .second_title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .title_btn {
    margin-left: 20px;
  }
  </style>
  